<template>
  <div></div>
</template>
<script>
  import { Card, Button, InfoSection, FormGroupInput, Checkbox } from '@/components';
  import db from '../../components/Firebase/firebaseInit'
  import firebase from 'firebase';
  import { loadStripe } from "@stripe/stripe-js"

  export default {
    name: 'pricing-page',
    bodyClass: 'pricing',
    components: {
      Card,
      InfoSection,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [FormGroupInput.name]: FormGroupInput
    },
      created() {
        window.location.href = "https://thesystemaus.com.au/packages";
      },
    data() {
        //  this.publishableKey = 'pk_live_51IN97OKdbJJr9GC2Qi97mYou5pY79RL215MwTV6iKre9BTcno9IrRQwIiA2ioW1YHoVWc3mNz3UnK0IfqPu8Mmzv00WrQPMeQm';
        return {
        emailSubscribe: true,
        email: '',
        email: '',
        password: '',
        loading: false,
        // lineItemsOne: [
        //   {
        //     price: 'price_1ITUQKKdbJJr9GC2GHPENg9n', // The id of the recurring price you created in your Stripe dashboard
        //     quantity: 1,
        //   },
        // ],
        // lineItemsTwo: [
        //   {
        //     price: 'price_1ITUQjKdbJJr9GC24eUf4Mko', // The id of the recurring price you created in your Stripe dashboard
        //     quantity: 1,
        //   },
        // ],
        // lineItemsThree: [
        //   {
        //     price: 'price_1ITUPLKdbJJr9GC2pl64sh3A', // The id of the recurring price you created in your Stripe dashboard
        //     quantity: 1,
        //   },
        // ],
        // lineItemsFour: [
        //   { 
        //     price: 'price_1ITUULKdbJJr9GC2JM0PrKYm', // The id of the recurring price you created in your Stripe dashboard
        //     quantity: 1,
        //   },
        // ],
        // successURL: 'https://aightbetnow.com',
        // cancelURL: 'https://aightbetnow.com/#/trumpyTips',
    };
  },
    methods: { 
    login () {
      this.emailSubscribe = false;
      const axios = require('axios');
      const qs = require('querystring');
      const url =
        'https://us-central1-aightbetnow-com.cloudfunctions.net/sendMail';

          const requestBody = {
            email: this.email
          }

          const config = {
            headers: {
              // 'Content-Type': 'application/x-www-form-urlencoded',

            }
          }

          axios.post(url, qs.stringify(requestBody), config)
            .then((result) => {
              // console.log(result.statusCode + " is the status");
              alert('We have sent you a link to manage your account. Go to your email and follow the link.');
              this.emailSubscribe = true;
              this.email = '';
            })
            .catch((err) => { 
              console.log(err + ' is the error')
              alert('Error subscribing');
               this.emailSubscribe = true;
            })
    },
    async checkoutStripe(price_id){
        this.loginButton = true;

        var createCheckoutSession = function(priceId) {
          return fetch("https://us-central1-aightbetnow-com.cloudfunctions.net/createCheckoutSession", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              priceId: priceId
            })
          }).then(function(result) {
            return result.json();
          });
        };

       let ider = price_id;
       const stripe = await loadStripe('pk_live_51IN97OKdbJJr9GC2Qi97mYou5pY79RL215MwTV6iKre9BTcno9IrRQwIiA2ioW1YHoVWc3mNz3UnK0IfqPu8Mmzv00WrQPMeQm');

        // You'll have to define PRICE_ID as a price ID before this code block
        createCheckoutSession(ider).then(function(data) {
          // Call Stripe.js method to redirect to the new Checkout page
                stripe
                  .redirectToCheckout({
                    sessionId: data.sessionId
                  })
                  // .then(handleResult);
          });
    },
    async checkoutStripePayment(price_id){
        this.loginButton = true;

        var createCheckoutSession = function(priceId) {
          return fetch("https://us-central1-aightbetnow-com.cloudfunctions.net/createCheckoutSessionPayment", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              priceId: priceId
            })
          }).then(function(result) {
            return result.json();
          });
        };

       let ider = price_id;
       const stripe = await loadStripe('pk_live_51IN97OKdbJJr9GC2Qi97mYou5pY79RL215MwTV6iKre9BTcno9IrRQwIiA2ioW1YHoVWc3mNz3UnK0IfqPu8Mmzv00WrQPMeQm');

        // You'll have to define PRICE_ID as a price ID before this code block
        createCheckoutSession(ider).then(function(data) {
          // Call Stripe.js method to redirect to the new Checkout page
                stripe
                  .redirectToCheckout({
                    sessionId: data.sessionId
                  })
                  // .then(handleResult);
          });
    },
    async checkoutStripeTrial(price_id){
        this.loginButton = true;

        var createCheckoutSession = function(priceId) {
          return fetch("https://us-central1-aightbetnow-com.cloudfunctions.net/createCheckoutSessionTrail", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              priceId: priceId
            })
          }).then(function(result) {
            return result.json();
          });
        };

       let ider = price_id;
       const stripe = await loadStripe('pk_live_51IN97OKdbJJr9GC2Qi97mYou5pY79RL215MwTV6iKre9BTcno9IrRQwIiA2ioW1YHoVWc3mNz3UnK0IfqPu8Mmzv00WrQPMeQm');

        // You'll have to define PRICE_ID as a price ID before this code block
        createCheckoutSession(ider).then(function(data) {
          // Call Stripe.js method to redirect to the new Checkout page
                stripe
                  .redirectToCheckout({
                    sessionId: data.sessionId
                  })
                  // .then(handleResult);
          });
    },
  }
  }
</script>
<style>
</style>
